import React, { useRef } from 'react'
import 'flatpickr/dist/themes/material_blue.css'
import Flatpickr from 'react-flatpickr'
import { Form, InputGroup } from 'react-bootstrap'
import { BsCalendar4 } from 'react-icons/bs'
import { FaTimes } from 'react-icons/fa'
import moment from 'moment'

function PickerRangeCustom({
  value,
  onChange,
  disabled = false,
  isClearable = true
}) {
  const refComp = useRef(null)

  return (
    <InputGroup className="">
      {!disabled ? (
        <Flatpickr
          ref={refComp}
          // defaultValue={value}
          value={value}
          onChange={onChange}
          className="form-control rounded-start border-end-0"
          options={{
            mode: 'range',
            altInput: true,
            altFormat: 'd/m/Y',
            dateFormat: 'Y-m-d'
          }}
        />
      ) : (
        <Form.Control
          className="border-end-0"
          value={value ? moment(value).format('DD/MM/YYYY') : ''}
          disabled={true}
        />
      )}

      <InputGroup.Text className="border-start-0 bg-white">
        {value && value.length > 0 && value[0] && isClearable && (
          <FaTimes
            style={{ color: '#b8b8b8' }}
            className="me-2 pointer-event"
            onClick={() => {
              refComp.current.flatpickr.clear()
            }}
          />
        )}
        <BsCalendar4 style={{ color: '#b8b8b8' }} />
      </InputGroup.Text>
    </InputGroup>
  )
}

export default PickerRangeCustom
